import type { UnavailableDate } from "@upsquad/shared";
import { Plus, Trash2 } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input, TextField } from "@/src/common/components/ui";
import { formatDisplayDate } from "@/src/common/lib/date.utils";

interface UnavailableDatesTabProps {
	dates: UnavailableDate[];
	onAdd: (date: string) => void;
	onDelete: (dateId: string) => void;
}

export function UnavailableDatesTab({ dates, onAdd, onDelete }: UnavailableDatesTabProps) {
	const { t } = useTranslation("member");
	const [newDate, setNewDate] = useState("");

	const handleAdd = () => {
		if (!newDate) return;
		onAdd(newDate);
		setNewDate("");
	};

	return (
		<div className="space-y-4">
			<div className="flex items-end gap-2">
				<TextField className="flex-1">
					<Input type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} />
				</TextField>
				<Button variant="outline" onPress={handleAdd} isDisabled={!newDate}>
					<Plus size={16} />
					{t("availability.add_date")}
				</Button>
			</div>

			{dates.length > 0 && (
				<div className="space-y-2">
					{dates.map((d) => (
						<div key={d.id} className="flex items-center justify-between rounded-lg border border-divider p-3">
							<span className="text-sm">{formatDisplayDate(d.date)}</span>
							<button type="button" onClick={() => onDelete(d.id)} className="text-danger hover:text-danger/80">
								<Trash2 size={14} />
							</button>
						</div>
					))}
				</div>
			)}

			{dates.length === 0 && <p className="text-sm text-foreground/50 text-center py-4">{t("availability.no_dates")}</p>}
		</div>
	);
}
